export const eventNames = Object.freeze({
  PAGE_VIEW_SPECIALTY_DOCTOR: 'Visualizar página de especialidade',
  PAGE_VIEW_LOCAL: 'Visualizar página de local',
  CTA: 'CTA',
  CHOOSE_HOUR: 'Escolher Horarios',
  FILTER_HOURS: 'Filtrar Horarios',
  CHOOSE_LOCAL: 'Escolher Local',
  FALLBACK: 'Fallback',
  INTERACT_WITH_APP: 'Interagir com aplicacao',
  SELECT_SPECIALTY_DOCTOR: 'Escolher Especialidade e/ou Medico',
  OPEN_CHAT: 'Abrir Atendimento via Chat',
  SELECT_PAYMENT: 'Escolher Forma de Pagamento',
  SHOW_GENERIC_ERROR: 'Exibir Erro Generico',
  SHOW_GENERIC_ERROR_BACKEND: 'Exibir Erro Generico backend',
  PAGE_VIEW_SUCESS_APPOINTMENT: 'Visualizar página de sucesso',
  CANCEL_SCHEDULE: 'Cancelar Consulta',
  LIST_SCHEDULE: 'Listar Horarios',
  DOWNLOAD_APP: 'Baixar App AP',
  MODAL_FALLBACK_PRIVATE_SUGGESTION: 'modal_fallback_sugestao_particular',
  CTA_SECURITY_TOKEN: 'CTA_token_seguranca',
  TOKEN_PAGE_VIEW: 'Visualizar token',
  CART_RECOVERY: 'recuperacaoCarrinho',
  MODAL_DUPLICATED_SCHEDULE: 'modal_duplicidade',
  DUPLICATED_SCHEDULE_PAGE: 'pg_duplicidade'
})
